<template>
    <div class="bg">
        <div class="backg"></div>
        <div class="content">
            <img :src="appdownloadbg" alt="">
        </div>
    </div>
</template>
<script>
import appdownloadbg from '@/assets/appdownloadbg.png'
export default {
    props:['backColor'],
    data(){
        return {
            appdownloadbg ,
        }
    }
}
</script>
<style scoped lang="less">
    .bg{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 80px;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1000;
        overflow: hidden;
        .backg{
            position: fixed;
            top: 80px;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 900;
            background:rgba(0, 0, 0, 0.4);
            z-index: 50;
        }
        .content{
            width: 100%;
            height: auto;
            overflow: hidden;
            background: #fff;
            position: inherit;
            z-index: 100;
            box-shadow: 0px 1px 0px 0px #EEEEEE;
            img{
                width: 1248px;
                height: 391px;
                display: block;
                overflow: hidden;
                margin: 0 auto;
                margin-top: 33px;
                margin-bottom: 26px;
            }
        }
        
    }
</style>